import { PlatformBrandKitState } from './types';

const getters = {
  getBrandKits(state: PlatformBrandKitState) {
    return state.brandKits;
  },
  isBrandKitLoaded(state: PlatformBrandKitState) {
    return state.isLoaded;
  }
};

export type BrandKitGetters = {
  [k in keyof typeof getters]: ReturnType<(typeof getters)[k]>;
};

export default getters;
